import { useState } from 'react'

const StatCard = ({ title, value, icon: Icon, trend, trendLabel, color = 'red', loading = false }) => {
  const [isHovered, setIsHovered] = useState(false)

  const colorClasses = {
    red: {
      bg: 'bg-red-50 dark:bg-red-900/20',
      icon: 'text-red-600 dark:text-red-400',
      border: 'border-red-200 dark:border-red-800',
      hover: 'hover:border-red-300 hover:bg-red-100 dark:hover:border-red-700 dark:hover:bg-red-900/30'
    },
    blue: {
      bg: 'bg-blue-50 dark:bg-blue-900/20',
      icon: 'text-blue-600 dark:text-blue-400',
      border: 'border-blue-200 dark:border-blue-800',
      hover: 'hover:border-blue-300 hover:bg-blue-100 dark:hover:border-blue-700 dark:hover:bg-blue-900/30'
    },
    green: {
      bg: 'bg-green-50 dark:bg-green-900/20',
      icon: 'text-green-600 dark:text-green-400',
      border: 'border-green-200 dark:border-green-800',
      hover: 'hover:border-green-300 hover:bg-green-100 dark:hover:border-green-700 dark:hover:bg-green-900/30'
    },
    yellow: {
      bg: 'bg-yellow-50 dark:bg-yellow-900/20',
      icon: 'text-yellow-600 dark:text-yellow-400',
      border: 'border-yellow-200 dark:border-yellow-800',
      hover: 'hover:border-yellow-300 hover:bg-yellow-100 dark:hover:border-yellow-700 dark:hover:bg-yellow-900/30'
    },
    purple: {
      bg: 'bg-purple-50 dark:bg-purple-900/20',
      icon: 'text-purple-600 dark:text-purple-400',
      border: 'border-purple-200 dark:border-purple-800',
      hover: 'hover:border-purple-300 hover:bg-purple-100 dark:hover:border-purple-700 dark:hover:bg-purple-900/30'
    },
    orange: {
      bg: 'bg-orange-50 dark:bg-orange-900/20',
      icon: 'text-orange-600 dark:text-orange-400',
      border: 'border-orange-200 dark:border-orange-800',
      hover: 'hover:border-orange-300 hover:bg-orange-100 dark:hover:border-orange-700 dark:hover:bg-orange-900/30'
    }
  }

  const currentColor = colorClasses[color] || colorClasses.red // fallback к red если цвет не найден

  if (loading) {
    return (
      <div className="relative p-6 rounded-lg border animate-pulse bg-gray-100 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between mb-4">
          <div className="p-2 rounded-lg bg-gray-200 dark:bg-gray-700 h-10 w-10" />
        </div>
        <div className="mb-2">
          <div className="h-9 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
        <div className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
      </div>
    )
  }

  return (
    <div
      className={`relative p-6 rounded-lg border transition-all duration-200 ${currentColor.bg} ${currentColor.border} ${currentColor.hover}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Иконка */}
      <div className="flex items-center justify-between mb-4">
        <div className={`p-2 rounded-lg ${currentColor.bg} ${currentColor.icon}`}>
          <Icon className="h-6 w-6" />
        </div>
        
        {/* Индикатор тренда */}
        {trend && (
          <div className={`text-sm font-medium ${
            typeof trend === 'string' && trend.startsWith('+') 
              ? 'text-green-600 dark:text-green-400' 
              : typeof trend === 'string' && trend.startsWith('-')
              ? 'text-red-600 dark:text-red-400'
              : 'text-light-text-secondary dark:text-dark-text-secondary'
          }`}>
            {typeof trend === 'string' ? trend : `+${trend}`}
            <span className="text-xs text-light-text-tertiary dark:text-dark-text-tertiary ml-1">{trendLabel}</span>
          </div>
        )}
      </div>

      {/* Значение */}
      <div className="mb-2">
        <p className="text-3xl font-bold text-light-text-primary dark:text-dark-text-primary">
          {typeof value === 'number' ? value.toLocaleString() : value}
        </p>
      </div>

      {/* Заголовок */}
      <p className="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">
        {title}
      </p>

      {/* Анимированный индикатор */}
      <div className={`absolute bottom-0 left-0 h-1 bg-gradient-to-r ${currentColor.icon} transition-all duration-300 ${
        isHovered ? 'w-full' : 'w-0'
      }`} />
    </div>
  )
}

export default StatCard